import { render, staticRenderFns } from "./OverwhelmingOffer.vue?vue&type=template&id=05071f24&scoped=true&"
import script from "./OverwhelmingOffer.vue?vue&type=script&lang=ts&"
export * from "./OverwhelmingOffer.vue?vue&type=script&lang=ts&"
import style0 from "./OverwhelmingOffer.vue?vue&type=style&index=0&id=05071f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05071f24",
  null
  
)

export default component.exports